const updateSectionsContent = () => {
  const data = {
    sections: ['cart-items', 'cart-icon-bubble', 'free-shipping-bar', 'cart-icon', 'cart-price'],
  };

  const cartContents = fetch('/?sections=cart-items,free-shipping-bar,cart-price', {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  return cartContents;
};
const updateQty = (variantId, qty) => {
  const data = {
    id: variantId,
    quantity: qty,
    sections: ['cart-items', 'cart-icon-bubble', 'free-shipping-bar', 'cart-icon', 'cart-price'],
  };

  const cartContents = fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  return cartContents;
};

const addNewItem = (variantId, qty) => {
  const data = {
    id: variantId,
    quantity: qty,
    sections: ['cart-items', 'cart-icon-bubble', 'free-shipping-bar', 'cart-icon', 'cart-price'],
  };

  const cartContents = fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  return cartContents;
};


class SideCart extends HTMLElement {
  constructor() {
    super();
    this.drawerToggles = [...document.querySelectorAll('[data-drawer-toggle]')];
    this.addCartBtns = [...document.querySelectorAll('[data-add-cart]')];
    this.bgContainer =   this.querySelector('[data-bg]');
    this.sidecart =   this.querySelector('[data-sidecart]');
    this.giftContainer = this.querySelector('[data-gift]');
    this.cartContainer = this.querySelector('[data-cart-container]');
    this.cartItemsContainer = this.querySelector('[data-cart-items]')
    this.shippingBar = this.querySelector("[data-shipping-bar]");
    this.cart = {};
  }
  connectedCallback() {
    if(this.giftContainer){
      this.giftContainer.querySelector("[name='gift-option']").addEventListener('change', (e) => {
        localStorage.setItem('gift', $("[name='gift-option']").is(":checked"))
        if(!$("[name='gift-option']").is(":checked") || this.giftContainer.querySelector('[data-hasgift]').offsetHeight === 0){
          this.toggleGift();
        }
      })
      let wrap = this
      this.giftContainer.querySelector(".gift-trigger").addEventListener('click', function() {
        wrap.toggleGift();
      })

      let isGift = localStorage.getItem('gift')
      if(isGift == 'true') {
        $("[name='gift-option']").prop("checked", true).trigger("change");
      }
    }
    let scope = this;
    window.addEventListener('resize', function(event) {
        scope.setItemContainer();
    }, true);
    this.setItemContainer();
    this.drawerToggles.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.dataset.isOpen) {
          // this.close();
          document.location.reload();
          setTimeout(() => {
            this.close();
          }, 1500);
        } else {
          this.open();
        }
      });
    });

    //this.open();

    this.addListeners();
    this.bundle()
  }

  addListeners() {

    [...this.querySelectorAll('[data-delete]')].forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        updateQty(el.dataset.delete, 0)
          .then((data) => {
            this.cart = data;
          })
          .finally(() => {
            if(this.cart.items.length == 1){
              const giftID = this.giftContainer.querySelector("[name='gift-add']")
              if(giftID){
                if(this.cart.items[0].id == giftID.dataset.id){
                  const removeItem = this.querySelector(`[data-delete="${giftID.dataset.id}"]`);
                  if(removeItem){
                    removeItem.click();
                  }
                }
              }
            }
            this.renderCartItems();
            this.addListeners();
          });
      });
    });

    [...this.querySelectorAll('[data-update]')].forEach((el) => {
      el.addEventListener('click', () => {
        updateQty(el.dataset.update, el.dataset.qty)
          .then((data) => {
            this.cart = data;
          })
          .finally(() => {
            this.renderCartItems();
            this.addListeners();
          });
      });
    });
  }

  setItemContainer(){
    const height = window.innerHeight;
    const top = this.querySelector('.top-container').offsetHeight;
    const bottom = this.querySelector('.bottom-container')?.offsetHeight;
    this.cartContainer.style.height = (height - top - bottom) + 'px';
  }

  toggleGift(){
    this.giftContainer.querySelector('[data-hasgift]').style.height = this.giftContainer.querySelector('[data-hasgift]').offsetHeight === 0 ? `305px` : '0px';
    if(this.giftContainer.querySelector('[data-hasgift]').offsetHeight != 0 ){
      setTimeout(() => {
          this.setItemContainer();
      }, 500);
    }
    $('.gift-trigger').toggleClass('open')
  }
  open() {
    this.setAttribute('data-is-open', true);
    this.sidecart.classList.remove('translate-x-full');
    this.bgContainer.classList.remove('-translate-x-full');
    // document.querySelector('body').classList.add('fixed');
    document.querySelector('body').classList.add('w-screen');
    // this swaps the burger button with the close button
    // window.addEventListener('click', (e) => {
    //   this.handleBodyClick(e);
    // });
    $('#yotpo_testimonials_btn').hide()
  }

  async renderCartItems() {
    if (this.cart?.sections?.['cart-items']) {
        this.cartItemsContainer.innerHTML = this.cart.sections['cart-items'];
        if(this.cartContainer.querySelector("[data-cart-contents]")){
           this.querySelector('.bottom-container').classList.remove('hidden');
        }else{
           this.querySelector('.bottom-container').classList.add('hidden');
        }
    }
    if(this.cart?.sections?.['free-shipping-bar']){
      this.shippingBar.innerHTML = this.cart.sections['free-shipping-bar'];
    }
    if(this.cart?.sections?.['cart-icon']){
      this.querySelector('[data-cart-icon]').innerHTML = this.cart.sections['cart-icon'];
    }
    if(this.cart?.sections?.['cart-price']){
      this.querySelector('[data-total]').innerHTML = this.cart.sections['cart-price'];
    }
    // if (this.cart?.sections?.['cart-toggle-with-item-count']) {
    //   this.cartToggles.forEach((toggle) => {
    //     const el = toggle;
    //     el.innerHTML = this.cart.sections['cart-toggle-with-item-count'];
    //   });
    // }
  }
  updateSections(){
    jQuery.getJSON('/cart.js', function(cart) {
      $('.cart-bubble-count').text(cart.item_count)
      $('[data-cart-icon] span').text(cart.item_count)
    });

    updateSectionsContent().then((data) => {
      this.cart.sections = data;
    })
    .finally(() => {
      this.renderCartItems();
      this.addListeners();
      this.open();      
    });


  }

  refresh(data) {
    this.cart = data;
    this.renderCartItems();
    this.addListeners();
    this.open();
  }
  close() {
    this.removeAttribute('data-is-open', true);
    this.sidecart.classList.add('translate-x-full');
    this.bgContainer.classList.add('-translate-x-full');
    document.querySelector('body').classList.remove('fixed');
    document.querySelector('body').classList.remove('w-screen');
    // window.removeEventListener('click', (e) => {
    //   this.handleBodyClick(e);
    // });
    $('#yotpo_testimonials_btn').show()
  }
  bundle() {
    let self = this

    async function removeBundle(id, callback) {
      let data = ''

      $.ajax({
				type: 'GET',
				url: '/cart.js',
				dataType: 'json',
				success: function (cart) {
          cart.items.forEach(function(item) {
            if(item.properties.bundleId == id) {
              let key = item.key
            
              if (!data) {
                data = `updates[${key}]=0`
              } else {
                data += `&updates[${key}]=0`
              }
            }
          })

          if(!data) {
            callback && callback()
            return true
          }
          
          jQuery.post('/cart/update.js', data).done( function() { 
            removeBundle(id, callback)
            self.updateSections()
          })
				},
			});
    }

    function editBundle(id) {
      $.ajax({
				type: 'GET',
				url: '/cart.js',
				dataType: 'json',
				success: function (cart) {
          let item = cart.items.filter(item => item.properties.bundleId == id && item.properties.isbundlePack)        
          localStorage.setItem("bundle", item[0].properties.selectedProducts);
          localStorage.setItem('product_bundle',item[0].properties.selectedProducts)
          removeBundle(id, function() {
            window.location.href = '/collections/build-a-bundle'
          })
				},
			});
    }

    function updateQuantity(id, name) {
      $.ajax({
				type: 'GET',
				url: '/cart.js',
				dataType: 'json',
				success: function (cart) {
          console.log(cart)
          let data
          let bundle = JSON.parse(cart.items.filter(item => item.properties.bundleId == id && item.properties.isbundlePack)[0].properties.selectedProducts) 
          console.log(bundle)

          if(name == 'plus') {
            cart.items.forEach(function(item) {
              if(item.properties.bundleId == id && item.properties.isbundlePack) {
                let key = item.key
                data = `updates[${key}]=${item.quantity + 1}`
              }
            })
  
            cart.items.forEach(function(item) {
              if(item.properties.bundleId == id && !item.properties.isbundlePack) {
                let key = item.key
                let originalQuantity = bundle.filter(bundleItem => bundleItem.id == item.id)[0].quantity
                data += `&updates[${key}]=${item.quantity + originalQuantity}`
              }
            })
          }
          
          if(name == 'minus') {
            cart.items.forEach(function(item) {
              if(item.properties.bundleId == id && item.properties.isbundlePack) {
                let key = item.key
                data = `updates[${key}]=${item.quantity - 1}`
              }
            })
  
            cart.items.forEach(function(item) {
              if(item.properties.bundleId == id && !item.properties.isbundlePack) {
                let key = item.key
                let originalQuantity = bundle.filter(bundleItem => bundleItem.id == item.id)[0].quantity
                data += `&updates[${key}]=${item.quantity - originalQuantity}`
              }
            })
          }
          
          jQuery.post('/cart/update.js', data).done( function() { 
            self.updateSections()
          })
    
				},
			});
    }

    $(document).click(function(e) {
      // remove bundle
      if($(e.target).hasClass('removeBundle')) {
        let id = $(e.target).closest('.cart-item').data('bundle-id')
        $(e.target).closest('.cart-item').addClass('opacity-50')
        removeBundle(id)
      }

      // edit bundle
      if($(e.target).hasClass('edit-bundle')) {
        let id = $(e.target).closest('.cart-item').data('bundle-id')
        $(e.target).closest('.cart-item').addClass('opacity-50')
        editBundle(id)
      }

      // update quantity
      if($(e.target).hasClass('bundle-quantity__button')) {
        let id = $(e.target).closest('.cart-item').data('bundle-id')
        $(e.target).closest('.quantity').addClass('opacity-50')
        let name = $(e.target).attr('name')
        updateQuantity(id, name)
      }
      
    })
  }
}

customElements.define('side-cart', SideCart);
